export const TYPE_OBLIGATORY = 'obligatory';
export const TYPE_OBLIGATORY_REVERSED = 'obligatory_reversed';
export const TYPE_OPTIONAL = 'optional';
